import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { Trans } from '@lingui/macro'
import { QRcode } from '@yoti/ui-kit-components-react/qr-code'

import { SkinContext } from '@yoti-web-share/skins'

import ForbiddenError from '@yoti-web-share/share-flow/src/errors/ForbiddenError'
import NotFoundError from '@yoti-web-share/share-flow/src/errors/NotFoundError'

import getCurrentState from './getCurrentState'
import getContent from './getContent'
import withClientAndShare from '../../hoc/withClientAndShare'
import PartnershipApps from '../../components/PartnershipApps/PartnershipApps'
import { PARTNERSHIP_APPS_LAYOUTS } from '../../components/PartnershipApps'

import './ShareQr.scss'

const showRetryLink = isRetryable => !isRetryable && { retryButton: '' }

const isShareInvalid = shareError => shareError instanceof ForbiddenError
  || shareError instanceof NotFoundError

export const ShareQr = ({
  clientError,
  clientClosingType,
  clientConfiguration,
  shareError,
  shareQrCodeUrl,
  shareStatus,
  shareActions
}) => {
  const { supportedApps } = useContext(SkinContext)

  const { qr: { title } = {}, learnMoreLink } = clientConfiguration
  const { initialise: initialiseShare } = shareActions

  const currentState = getCurrentState(shareStatus, clientError || shareError)
  const contentForQrStates = getContent({ closeType: clientClosingType })

  const shareInvalid = isShareInvalid(shareError)

  const supportsMultipleApps = supportedApps.length > 1

  const titleValue = (typeof title === 'string')
    ? title
    : contentForQrStates.title
  const content = {
    ...contentForQrStates,
    bottomSection: supportsMultipleApps && <PartnershipApps layout={PARTNERSHIP_APPS_LAYOUTS.STACK} />,
    title: titleValue,
    ...showRetryLink(!shareInvalid),
    ...(learnMoreLink && {
      link: {
        href: learnMoreLink,
        text: <Trans>How to set up your Yoti</Trans>
      }
    })
  }

  return (
    <div className="share-qr">
      <div className="yoti-qr">
        <QRcode
          content={content}
          value={shareQrCodeUrl}
          currentState={currentState}
          onRefresh={initialiseShare}
          colourisedYotiTrustMark={false}
        />
      </div>
    </div>
  )
}

ShareQr.defaultProps = {
  clientError: undefined,
  clientConfiguration: {},
  clientClosingType: '',
  shareError: undefined,
  shareStatus: '',
  shareQrCodeUrl: ''
}

ShareQr.propTypes = {
  clientError: PropTypes.objectOf(PropTypes.any),
  clientClosingType: PropTypes.string,
  clientConfiguration: PropTypes.shape({
    qr: PropTypes.shape({
      title: PropTypes.string,
    }),
    learnMoreLink: PropTypes.string,
    skinId: PropTypes.string
  }),
  clientActions: PropTypes.shape({
    setDimensions: PropTypes.func.isRequired,
  }).isRequired,
  shareError: PropTypes.objectOf(PropTypes.any),
  shareStatus: PropTypes.string,
  shareQrCodeUrl: PropTypes.string,
  shareActions: PropTypes.shape({
    initialise: PropTypes.func.isRequired,
  }).isRequired

}

export default withClientAndShare(ShareQr)
